export default "__VITE_ASSET__PxA1CRkF__"